import { html } from 'lit';
const NewXxxEdgeless =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M6.5 4.75a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5M3.25 6.5a3.25 3.25 0 0 1 6.49-.25c.794.001 1.56.016 2.357.208.897.217 1.79.645 2.853 1.442l.02.015.02.017c.864.745 1.475 1.75 1.841 2.826a.75.75 0 0 1-1.42.484c-.294-.865-.766-1.62-1.382-2.158-.928-.692-1.633-1.01-2.284-1.168-.675-.162-1.334-.166-2.244-.166A3.26 3.26 0 0 1 7.25 9.663v3.674a3.251 3.251 0 1 1-1.5 0V9.663A3.25 3.25 0 0 1 3.25 6.5m3.25 8.25a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5m11-1a.75.75 0 0 0-1.5 0V16h-2.25a.75.75 0 0 0 0 1.5H16v2.25a.75.75 0 0 0 1.5 0V17.5h2.25a.75.75 0 0 0 0-1.5H17.5z" clip-rule="evenodd"/>
  </svg>
`;
export default NewXxxEdgeless;
